module.exports = __webpack_public_path__ + "img/12.bc31855a.png";